import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { useCallback } from "react";

import { cn } from "@/lib/chillnn/cn";

import { QuestionCardItem } from "@/components/features/items/edit/_shared/ui/components/system/question/card/card-item";

import DragIndicator from "@/components/ui/icon/drag-indicator";

import { SubOptionItem } from "./sub-option-item";

import type { SubOptionRowProps } from "./sub-option-row";

type Props = SubOptionRowProps;

/** `QuestionOptionSubOptions` でサブオプションが2件以上のときのみマウントする。`useSortable` でラップした並べ替え可能行。 */
export const SortableSubOptionRow = ({
	subOption,
	index,
	removeSubOption,
	onSetSubOptionName,
	onSetIsShowTimeSchedule,
	onSetStartAt,
	onSetEndAt,
	onSetIsNextMorning,
	onSetMaxDailyStockNum,
	onSetPriceAmount,
}: Props) => {
	const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition, isDragging } = useSortable({
		id: subOption.subOptionID?.value ?? "",
	});

	const style = {
		transform: CSS.Transform.toString(transform),
		transition,
	};

	const handleRemoveItem = useCallback(() => {
		removeSubOption(index);
	}, [removeSubOption, index]);

	return (
		<QuestionCardItem
			removeItem={handleRemoveItem}
			ref={setNodeRef}
			style={style}
			className={cn(isDragging && "!cursor-grabbing")}
		>
			<div
				ref={setActivatorNodeRef}
				className="absolute left-4 top-4"
				aria-label="サブオプションの並べ替え"
				{...attributes}
				{...listeners}
			>
				<DragIndicator
					className={cn(
						"text-caption-50 hover:cursor-grab",
						isDragging ? "!cursor-grabbing" : "cursor-grab",
					)}
					size="default"
				/>
			</div>
			<SubOptionItem
				subOption={subOption}
				index={index}
				mainSectionClassName="pl-10"
				onSetSubOptionName={onSetSubOptionName}
				onSetIsShowTimeSchedule={onSetIsShowTimeSchedule}
				onSetStartAt={onSetStartAt}
				onSetEndAt={onSetEndAt}
				onSetIsNextMorning={onSetIsNextMorning}
				onSetMaxDailyStockNum={onSetMaxDailyStockNum}
				onSetPriceAmount={onSetPriceAmount}
			/>
		</QuestionCardItem>
	);
};

SortableSubOptionRow.displayName = "SortableSubOptionRow";
